import React, { useEffect, useRef, useState } from "react";
import { format, subMonths } from 'date-fns';

import { ChartEntry } from "../components/chartEntry";
import { PlayerDevice } from "../components/playerDevice";

export const ChartsPage = ({chartEntries}) => {
    const Player = useRef(null);
    const ActiveTrackRef = useRef(null);
    const [currentVideoIndex, setCurrentVideo] = useState(0);
    const [autoplay, setAutoplay] = useState(false);

    // CONTROL EVENTS
    const playNextVideo = () => setCurrentVideo(currentVideoIndex + 1);
    const playPreviousVideo = () => setCurrentVideo(currentVideoIndex - 1);
    const toggleAutoplay = () => setAutoplay(!autoplay);
    const getCurrentTrack = () => chartEntries[currentVideoIndex] || { ytid: 'M91VPs47jZc' };
    const playVideo = (ndx) => {
        setCurrentVideo(ndx);
    };

    useEffect(() => {
        const { ytid } = getCurrentTrack();
        if (Player.current) {
            Player.current.loadVideoById(ytid);
        }
    }, [currentVideoIndex]);

    // PLAYER EVENTS
    const onReady = (event) => {
        Player.current = event.target;
    };
    const onEnd = () => {
        if (autoplay) {
            playNextVideo();
        }
    };
    const onError = () => playNextVideo();
    //
    const onPlay = () => {};
    const onPause = () => {};
    const onStateChange = () => {};

    const events = { onReady, onPlay, onPause, onEnd, onError, onStateChange };
    const initialEntry = Object.create(getCurrentTrack());
    const prevMonth = subMonths(new Date, 1);
    const editionTitleText = format(prevMonth, "MMMM yyyy");
    const autoplayText = autoplay ? "AUTOPLAY OFF" : "ENABLE AUTOPLAY";

    const scrollToActiveTrack = () => {
        window.scrollTo({
            top: ActiveTrackRef.current.offsetTop - 20,
            left: 0,
            behavior: 'smooth'
        });
    }

    return <main>
        <header>
            <h1 className='logo'>HumanMusic charts</h1>
            <p>
                <span>About</span>
                HumanMusic charts is an indie music discovery engine which takes recommendations from 500 music blogs covering diverse genres.
                We always display the previous month's results. <a href='https://tibor.szasz.hu/blog/humanmusic-charts' target='_blanky'>Read more</a> about in more detail.
            </p>
        </header>
        <section className='toolbar'>
            <h1 className='edition'>{editionTitleText}</h1>
        </section>
        <section className='player'>
            <section className='entries'>
                {chartEntries.map((entry, i) => {
                    return <ChartEntry
                        key={entry.ytid + i}
                        index={i}
                        entry={entry}
                        playCallback={playVideo}
                        trackActivationEvent={ref => {
                            ActiveTrackRef.current = ref;
                        }}
                        active={currentVideoIndex === i}
                    />
                })}
                {!chartEntries.length && (
                    <>
                        <h3>No entries found for this month</h3>
                        <p>Error code: #00000000-00000000-00000001</p>
                        <p>¯\_(ツ)_/¯</p>
                    </>
                )}
            </section>
            <section className='player-device'>
                <PlayerDevice initialId={initialEntry.ytid} events={events} />
                <article className='control'>
                    <button onClick={toggleAutoplay} className={autoplay ? 'active' : undefined}>{autoplayText}</button>
                    <button onClick={playPreviousVideo}>PREVIOUS</button>
                    <button onClick={playNextVideo}>NEXT</button>
                </article>
                <p>Current track {currentVideoIndex + 1} / {chartEntries.length} {currentVideoIndex < 0 && <>...you just had to try it, right? :)</>}</p>
                <button onClick={scrollToActiveTrack} className='scrollto'>Scroll to current track</button>
            </section>
        </section>
        <footer>HumanMusic {format(new Date, "yyyy")} | built by <a href='https://twitter.com/tiborsaas' target='_blank'>@tiborsaas</a></footer>
    </main>;
}
